import React from 'react';
import { getWorkDocList } from '../../api/workdoc'
import PageList from '../../components/PageListAPI'
import { useCan } from 'src/hooks/useCan';
import { SLUGS } from 'src/enum/permissions.enum';

export default function WorkDocList(props) {
  const can = useCan()
  return (
    <div className='App-paper'>
      <PageList
        name='workDocList'
        title='Рабочая документация'
        createItem={can(SLUGS.WORK_DOC.MANAGE)}
        columns={[
          { id: 'dateCreate', name: 'Дата создания', type: 'date' },
          { id: 'title', name: 'Наименование' },
          { id: 'user', name: 'Добавил' },
        ]}
        loadAPI={{
          request: getWorkDocList
        }}
        headerInit={{
          sortBy: 'dateCreate',
          sortDirection: 'desc',
        }}
        {...props}
      />
    </div>
  )
}